const graphAppConfig = {
    clientID: "90716ec8-8121-4b9d-8325-a63eba40b4f8",
    //redirectUri: "http://localhost:64067/",
    //interactionMode: "popUp",
    //graphEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphScopes: ["user.read mail.send calendars.readwrite"]
}

export default graphAppConfig;